export default __webpack_public_path__ + "static/media/04c_fold-21.45868fb6.mp4";